// extracted by mini-css-extract-plugin
export default {"redBorder":"paperMatrixQues_redBorder__kBqug","greenBorder":"paperMatrixQues_greenBorder__+9iew"};